import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { checkIsStyleArticle } from "~/components/article/article-render/style-article/helper";
import type { articleDividerArticle$key } from "~/queries/__generated__/articleDividerArticle.graphql";

import { Divider } from "./styles";

export type Props = {
  className?: string;
  reference: articleDividerArticle$key;
};

export const ArticleDivider: FunctionComponent<Props> = ({ className, reference: reference_ }) => {
  const article = useFragment(
    graphql`
      fragment articleDividerArticle on Article {
        ...helpersCheckIsStyleArticle
      }
    `,
    reference_,
  );

  if (checkIsStyleArticle(article)) return null;

  return <Divider className={className} />;
};

ArticleDivider.displayName = "ArticleDivider";
